export default "__VITE_ASSET__629c4d37__"